import 'swiper/dist/css/swiper.css'
import Swiper from 'swiper'

// Initializes a Swiper slider on the given element.
// https://idangero.us/swiper/
//
// If there is only 1 slide, slider initialization is skipped. DOM is still prepared to ensure proper styling.

const MAX_SLIDES_FOR_BULLET_PAGINATION = 6
const XS_BREAKPOINT = 576
const SM_BREAKPOINT = 768
const MD_BREAKPOINT = 992
const SECONDS_PER_SLIDE = 7

up.compiler('[slider]', (element, data) => {
  let autoplay = ('autoplay' in data) ? data.autoplay : false
  let slidesPerView = ('slidesPerView' in data) ? data.slidesPerView : 2
  let grouped = ('grouped' in data) ? data.grouped : true
  let insidePagination = ('insidePagination' in data) ? data.insidePagination : true

  let slides = element.querySelectorAll('.slider--slide')
  let slidesWrapper = document.createElement('div')
  slidesWrapper.classList.add('swiper-wrapper')
  let container = document.createElement('div')
  container.classList.add('swiper-container')
  container.appendChild(slidesWrapper)
  let containerWrapper = document.createElement('div')
  container.classList.add('slider--container-wrapper')
  containerWrapper.appendChild(container)

  for (let i = 0; i < slides.length; ++i) {
    slides[i].classList.add('swiper-slide')
    slides[i].parentElement.removeChild(slides[i])
    slidesWrapper.appendChild(slides[i])
  }

  element
    .appendChild(containerWrapper)
    .classList.add('-ready')

  if (slides.length > 1) {
    let paginationWrapper = document.createElement('div')
    paginationWrapper.classList.add('slider--pagination-wrapper')
    let pagination = document.createElement('div')
    pagination.classList.add('slider--pagination')
    pagination.classList.toggle('-inside', insidePagination)
    let previous = document.createElement('div')
    previous.classList.add('slider--previous')
    let next = document.createElement('div')
    next.classList.add('slider--next')

    paginationWrapper.appendChild(previous)
    paginationWrapper.appendChild(pagination)
    paginationWrapper.appendChild(next)
    element.appendChild(paginationWrapper)

    let swiperOptions = {
      direction: 'horizontal',
      autoplay: autoplay && { delay: SECONDS_PER_SLIDE * 1000 },
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: pagination,
        bulletClass: 'slider--pagination-bullet',
        bulletActiveClass: '-active',
        clickable: true,
        clickableClass: '-clickable',
      },
      breakpoints: {
        [XS_BREAKPOINT]: {},
        [SM_BREAKPOINT]: {},
        [MD_BREAKPOINT]: {},
      },
      // spaceBetween: 40, // grid gutter
      navigation: {
        prevEl: previous,
        nextEl: next,
        disabledClass: '-disabled',
      },
    }

    function assignViewportOptions(options, slidesPerView) {
      options.slidesPerView = slidesPerView
      if (grouped) {
        options.slidesPerGroup = slidesPerView
      }

      let numberOfSlides = slides.length
      let numberOfBullets = grouped ? (numberOfSlides / slidesPerView) : numberOfSlides

      if (numberOfBullets > MAX_SLIDES_FOR_BULLET_PAGINATION) {
        options.pagination = options.pagination || {}
        options.pagination.type = 'fraction'
      }
    }

    assignViewportOptions(swiperOptions, slidesPerView)

    if (slidesPerView > 1) {
      assignViewportOptions(swiperOptions.breakpoints[SM_BREAKPOINT], 1)
      assignViewportOptions(swiperOptions.breakpoints[MD_BREAKPOINT], 2)
    }

    let swiper = new Swiper(container, swiperOptions)

    return () => {
      swiper.destroy()
    }
  }
})
